<template>
  <div ref="domRef">
    <img
      v-show="$props.loading"
      class="loading-img"
      src="@/assets/images/common/pageend-loading.gif"
    />
    <slot></slot>
  </div>
</template>

<script setup>
import { getClientHeight } from "@/utils/dom.js";
import { ref, defineProps, defineEmits, onMounted, onBeforeUnmount } from "vue";

const $emits = defineEmits(["scroll"]);
const $props = defineProps({
  noMore: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
  },
  distance: {
    type: Number,
    default: 0,
  },
  // 开启出现在视野监听,只有出现在视野，才会触发触底
  isInViewObserver: {
    type: Boolean,
    default: false,
  },
});
const domRef = ref();
const infiniteScroll = () => {
  // console.log(this.pdDomId);
  if ($props.loading) return;
  const domTop = domRef.value.getBoundingClientRect().top;
  const clientHeight = getClientHeight();
  if ($props.noMore) return;
  if ($props.disabled) return;
  if (domTop - $props.distance <= clientHeight) {
    $emits("scroll");
  }
};

onMounted(() => {
  document.addEventListener("scroll", infiniteScroll);
});
onBeforeUnmount(() => {
  document.removeEventListener("scroll", infiniteScroll);
});
</script>

<style lang="scss" scoped>
.loading-img {
  width: 50px;
  height: 50px;
  margin: 20px auto;
  display: block;
}
</style>
